// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2501":"dfa7120a","7298":"4f8cbab3","7423":"4f8cbab3","7619":"4f8cbab3","8867":"976d85ad"}[chunkId] + ".chunk.css";
};